import { render } from "./AUtSales.vue?vue&type=template&id=f2c54a90&scoped=true"
import script from "./AUtSales.vue?vue&type=script&lang=js"
export * from "./AUtSales.vue?vue&type=script&lang=js"

import "./AUtSales.vue?vue&type=style&index=0&id=f2c54a90&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2c54a90"]])

export default __exports__